declare var nsjGlobals: any;
import angular from 'angular';
import moment from 'moment';

export class MeurhAdmissoesestagiarioDadospessoaisFormController implements angular.IController {

    static $inject = ['$scope', '$element', '$attrs', 'NewToaster', '$rootScope', '$sce', 'Paises'];

    public entity: any;
    public bloqueiaAno: any;
    public mesInit: any;
    public dataAtual = new Date();
    public dataMinima: any;
    public clienteAna: boolean;

    constructor(
        public $scope: angular.IScope,
        public $element: any,
        public $attrs: any,
        public NewToaster: any,
        public $rootScope: angular.IRootScopeService & { configuracoes: any, session: any },
        public $sce: angular.ISCEService,
        public Paises: any,
    ) {
        this.clienteAna = nsjGlobals.get('clienteana');
    }

    $onInit(): void {
        this.dataMinima = moment(this.dataAtual).subtract(18, 'years');
        this.bloqueiaQuatorzeanos();
        this.calculaMes();
    }

    preencheCidade(): void {
        if (this.valorExiste(this.entity.municipionascimento)) {
            this.entity.cidadenascimento = this.entity.municipionascimento.nome;
        } else {
            this.entity.cidadenascimento = null;
        }
    }

    bloqueiaQuatorzeanos(): any {
        this.bloqueiaAno = moment(this.dataMinima).add(4, 'years'); // =14 anos
    }

    calculaMes(): void {
        this.mesInit = moment(this.dataAtual).subtract(216, 'month'); // 18 anos
    }

    verificaEstabelecimento(): { estabelecimento: string } {
        if (this.entity.estabelecimento) {
          return { 'estabelecimento': this.entity.estabelecimento };
        } else {
          return { 'estabelecimento': this.$rootScope.session.entities.estabelecimento.estabelecimento };
        }
    }

    valorExiste(valor: any) {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }

    public alterarPossuiFilhos() {
        this.entity.possuifilhos = !this.entity.possuifilhos;
    }

    alteraPais() {
        if (!this.entity.paisnascimento || this.entity.paisnascimento.pais === '1058') {
            this.entity.datachegadapais = null;
            this.entity.temporesidenciaestrangeiro = null;
            this.entity.classificacaoestrangeiro = null;
            this.entity.municipionascimento = null;
            this.entity.cidadenascimento = null;
        } else if (this.entity.paisnascimento.pais !== '1058') {
            this.entity.municipionascimento = {
                ibge: '9999999',
                nome: 'EXTERIOR - EX',
                uf: 'EX'
            };

            this.entity.cidadenascimento = 'EXTERIOR';
        }
    }

    alteraSemFiliacao() {
        if (this.entity.semfiliacao) {
            this.entity.nomemae = this.entity.nomepai = null;
        }
    }

}
